
import React, { useState, ReactNode, cloneElement } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Card,
    CardContent,
    Avatar
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import {useTheme, alpha} from '@mui/material/styles';
import {SparkLineChart} from "@mui/x-charts/SparkLineChart";
import {LayoutFieldModel,
        IconType,
        IconJSON,
        RecordModel} from '../../models/models';
import {validateEmailField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import {FilterModel} from '../../models/modelsFilter';
import {CustomIconComponent} from '../icons/CustomIcon';
import {DateFilterComponent,
        WeekFilterComponent,
        MonthFilterComponent} from './DateFilter';
import {ForeignKeyFilterComponent} from './ForeignKeyFilter';
import {CharFilterComponent} from './CharFilter';
import { formatDate, formatDatetime } from "../../utils/dateFunctions";

export const FilterComponent: React.FC<{
  filter: FilterModel
  onChange: (filter: FilterModel) => void
}> = ({
  filter,
  onChange
}) => {

  /******************************/

  const handleDateChange = (value: Date, filter: FilterModel) => {
    const newDateText = formatDate(value)
    const newFilter = {...filter,
                       value: {...filter.value,
                               data: newDateText}}
    onChange(newFilter)
  }

  const handleForeignKeyChange = (value: any | null, filter: FilterModel) => {
    const newFilter = {...filter,
                       value: {...filter.value,
                               data: value}}
    onChange(newFilter)
  }

  const handleTextChange = (value: string, filter: FilterModel) => {
    const newFilter = {...filter,
                       value: {...filter.value,
                               data: value}}
    onChange(newFilter)
  }

  switch(filter.meta.fieldType){
    case "CharField":
      return (
        <CharFilterComponent
          filter={filter}
          onChange={handleTextChange}
        />
      )
    case "DateField":
      return (
        <DateFilterComponent
          filter={filter}
          onChange={handleDateChange}
        />
      )
    case "WeekField":
      return (
        <WeekFilterComponent
          filter={filter}
          onChange={handleDateChange}
        />
      )
    case "MonthField":
      return (
        <MonthFilterComponent
          filter={filter}
          onChange={handleDateChange}
        />
      )
    case "ForeignKey":
      return (
        <ForeignKeyFilterComponent
          filter={filter}
          onChange={handleForeignKeyChange}
        />

      )
    default:
      return (
       <Typography>
         Filter not yet implemented -- {filter.meta.fieldType}
       </Typography>
     )
   }

}
